import React from 'react';
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
import Tab from 'react-bootstrap/Tab'
import TabContainer from 'react-bootstrap/TabContainer'
import TabContent from 'react-bootstrap/TabContent'
import Nav from 'react-bootstrap/Nav'
// import { customerNameById, formatKennitala, formatKennitalaAsDate } from '../../utils'
import { customerNameById, formatKennitala, formatKennitalaAsDate, Spinner, getDescriptiveContractName } from '../../utils'
import connectWithStore from '../../utils/store'
import { SvgCheckIcon, SvgArrowIcon } from '../svg';

import { setInfoKey, setInfoKeyMulti } from '../../api/information-collection/actions'

import Alert from 'react-bootstrap/Alert'


import LinkButton from '../link-button';

class TilbodStepFinal extends React.Component {

    constructor(props) {
        super(props)
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }


    getInitialValues(customerId) {
        return this.props.infoCollection.data.find(f => f.customerId === customerId)
    }

    UNSAFE_componentWillMount() {
        Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) => {
            this.props.dispatch(setInfoKey({ key: undefined, value: undefined }, customerId))
        })
    }

    componentDidMount() {
        // Disable browser back button
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        });
    }

    render() {
        let customers = this.props.customers;
        const { contractSigning, isFetching, error_list, status } = this.props.offers

        return (
            <>
                <div className="row justify-content-center xs-pt-10 signature">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-50">
                            <Alert variant="success" className="col-xs-12 xs-mt-40 xs-mb-40 xs-p-30 centered">
                                <Alert.Heading>Gögn tilbúin</Alert.Heading>
                            </Alert>
                        </div>
                        <div className="row justify-content-center xs-pt-50">
                            <LinkButton className="btn btn-primary" to={location => `/sign/${contractSigning.signing_url}`} >Hefja undirritun</LinkButton>
                        </div>
                    </div>

                </div>
            </>

        )
    }
}

TilbodStepFinal.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection

    return f;
}

export default connectWithStore(store, TilbodStepFinal, mapStateToProps);
